import { Options } from "../models/response/game";

export enum STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
  ALL = -1,
}

export enum GENDER {
  MALE = 1,
  FEMALE = 0,
}

export const PAGE_SIZES = [100, 200, 300, 500];

export enum COMPUTER_STATUS {
  ALL = -1,
  INACTIVE = 0, // tạm ngưng máy
  AVAILABLE = 1, // Đang hoạt động
  IN_USE = 2, // Đang sử dụng
  MAINTENANCE = 3, // Bảo trì
  ERROR = 4, // Ngừng hoat động
  SHUTDOWN = 5, // Máy tắt
  SOCKET_RESTART_COMPUTER = 6, // socket reset máy trạm
  SOCKET_SHUTDOWN_COMPUTER = 7, // socket tăt máy trạm
  UPDATE_NOTE = 8, // tạo ghi chú và update ghi chú
  SCREENSHOT_COMPUTER_RECEIVED = 9, // chụp màn hình
  ALL_APPLICATIONS_COMPUTER_RECEIVED = 10, // danh sách ứng dụng máy trạm
  SOCKET_LOCK_COMPUTER = 11, // socket khoá máy trạm
  SOCKET_UNLOCK_COMPUTER = 12, // socket mở khoá máy trạm
  SOCKET_START_COMPUTER = 13, // socket mở  máy trạm
  SOCKET_RESTART_AREA = 14, // socket reset khu
  SOCKET_SHUTDOWN_AREA = 15, // socket tắt khu
  SOCKET_START_AREA = 16, // socket mở khu
}

export enum RESERVATION_STATUS {
  PENDING = 0,
  APPROVED = 1,
  CANCELED = 2,
}

export enum WALLET_TRANSACTION_STATUS {
  ALL = -1,
  PENDING = 0,
  COMPLETED = 1,
  FAILED = 2,
  CANCELED = 3,
}

export enum MODAL_TYPE {
  CREATE = 1,
  EDIT = 2,
  DETAIL = 3,
  STATUS = 4,
  RESET = 5,
  OTHER = 6,
}

export enum NEWS_PLATFORMS {
  ALL = -1,
  APP = 1,
  COMPUTER = 2,
}

export enum MEDIA_TYPE {
  IMAGE = 0,
  VIDEO = 1,
  LOCAL = -1,
}

export enum ORDER_STATUS {
  ALL = -1,
  PENDING = 1, // Chờ xác nhận
  CONFIRM = 2, // Bếp đã xác nhận
  COMPLETED = 3, // Bếp hoàn tất
  DONE = 4, // Hoàn tất
  CANCEL = 5, // Hủy

  // local
  CONFIRM_PAYMENT = 6, // Xác nhận thanh toán
  CHEF_CONFIRM = 7, // Bếp xác nhận
}

export enum PAYMENT_METHOD {
  CASH = 0,
  CARD = 1,
}

export enum FOOD_ORDER_PAYMENT_METHOD {
  CASH = 1, // Tiền mặt
  ACCOUNT_BALANCE = 2, // Tài khoản
}
export enum FOOD_ORDER_PAYMENT_METHOD_V2 {
  CASH = 0, // Tiền mặt
  MOMO = 1, // Tài khoản
  ACCOUNT_BALANCE = 2, // Tài khoản
  PAYOS = 3, // Tài khoản
}

export enum FOOD_ORDER_PAYMENT_TYPE {
  PREPAID = 1, // Thanh toán trước
  POSTPAID = 2, // Thanh toán sau
}

export enum WALLET_TYPE {
  MAIN = 1, // Ví chính
  SUB = 2, // Ví phụ
}

export enum PROMOTION_APPLY_TYPE {
  SINGLE = 0, // Chỉ áp dụng một khuyến mãi duy nhất
  MULTIPLE = 1, // Áp dụng đồng thời nhiều khuyến mãi
}

export enum INVENTORY_STATUS {
  PENDING = 1,
  COMPLETED = 2,
  CANCEL = 3,
}

export enum SYSTEM_RECEIPT_PAYMENTS_TYPE {
  CREATE = 0,
  ORDER = 1,
  WALLET = 2,
}

export enum SYSTEM_RECEIPT_STATUS {
  ALL = -1,
  PENDING = 0,
  COMPLETED = 1,
  CANCELED = 2,
}

export enum RECEIPT_STATUS {
  ALL = -1,
  PENDING = 1,
  COMPLETED = 2,
  CANCELED = 0,
}
export enum PAYMENT_METHOD_ORDER {
  CASH = 0,
  CARD = 1,
  ACCOUNT_BALANCE = 2,
  PAYOS = 3,
}

export enum PAYMENT_METHOD_BUY_HISTORY {
  ALL = -1,
  CASH = 0,
  MOMO = 1,
  ACCOUNT_BALANCE = 2,
  PAYOS = 3,
  BANK_TRANSFER = 5, // 01-contracts C-02 v4 (CR-9)
}

export const PAYMENT_METHOD_BUY_HISTORY_VALUES = {
  [PAYMENT_METHOD_BUY_HISTORY.ALL]: {
    id: PAYMENT_METHOD_BUY_HISTORY.ALL,
    label: "Tất cả phương thức",
    className: ``,
  },
  [PAYMENT_METHOD_BUY_HISTORY.MOMO]: {
    id: PAYMENT_METHOD_BUY_HISTORY.MOMO,
    label: "MoMo",
    className: `bg-[#D82D8B] text-white`,
  },
  [PAYMENT_METHOD_BUY_HISTORY.PAYOS]: {
    id: PAYMENT_METHOD_BUY_HISTORY.PAYOS,
    label: "PayOS",
    className: `bg-[#6655ff] text-white`,
  },
  [PAYMENT_METHOD_BUY_HISTORY.BANK_TRANSFER]: {
    id: PAYMENT_METHOD_BUY_HISTORY.BANK_TRANSFER,
    label: "Chuyển khoản (VietQR)",
    className: `bg-[#0E9F6E] text-white`,
  },
  [PAYMENT_METHOD_BUY_HISTORY.CASH]: {
    id: PAYMENT_METHOD_BUY_HISTORY.CASH,
    label: "Tiền mặt",
    className: "bg-[#42A5F5] text-white",
  },
  [PAYMENT_METHOD_BUY_HISTORY.ACCOUNT_BALANCE]: {
    id: PAYMENT_METHOD_BUY_HISTORY.ACCOUNT_BALANCE,
    label: "Tài khoản",
    className: "bg-[#FFC107] text-white",
  },
};

export const PAYMENT_METHOD_BUY_HISTORY_OBJECTS: Options[] = [
  {
    _id: PAYMENT_METHOD_BUY_HISTORY.ALL.toString(),
    name: PAYMENT_METHOD_BUY_HISTORY_VALUES[PAYMENT_METHOD_BUY_HISTORY.ALL].label,
  },
  {
    _id: PAYMENT_METHOD_BUY_HISTORY.CASH.toString(),
    name: PAYMENT_METHOD_BUY_HISTORY_VALUES[PAYMENT_METHOD_BUY_HISTORY.CASH].label,
  },
  {
    _id: PAYMENT_METHOD_BUY_HISTORY.MOMO.toString(),
    name: PAYMENT_METHOD_BUY_HISTORY_VALUES[PAYMENT_METHOD_BUY_HISTORY.MOMO].label,
  },
  {
    _id: PAYMENT_METHOD_BUY_HISTORY.PAYOS.toString(),
    name: PAYMENT_METHOD_BUY_HISTORY_VALUES[PAYMENT_METHOD_BUY_HISTORY.PAYOS].label,
  },
  {
    _id: PAYMENT_METHOD_BUY_HISTORY.ACCOUNT_BALANCE.toString(),
    name: PAYMENT_METHOD_BUY_HISTORY_VALUES[PAYMENT_METHOD_BUY_HISTORY.ACCOUNT_BALANCE].label,
  },
  {
    _id: PAYMENT_METHOD_BUY_HISTORY.BANK_TRANSFER.toString(),
    name: PAYMENT_METHOD_BUY_HISTORY_VALUES[PAYMENT_METHOD_BUY_HISTORY.BANK_TRANSFER].label,
  },
];

export enum PAYMENT_STATUS {
  ALL = -1,
  PAID = 1,
  UNPAID = 2,
  CANCEL = 3,
}

export const PAYMENT_STATUS_VALUES: { [key in PAYMENT_STATUS]: string } = {
  [PAYMENT_STATUS.ALL]: "Tất cả trạng thái thanh toán",
  [PAYMENT_STATUS.UNPAID]: "Chưa thanh toán",
  [PAYMENT_STATUS.PAID]: "Đã thanh toán",
  [PAYMENT_STATUS.CANCEL]: "Hủy",
};

export const PAYMENT_STATUS_OBJECTS: Options[] = [
  { _id: PAYMENT_STATUS.ALL.toString(), name: "Tất cả trạng thái thanh toán" },
  { _id: PAYMENT_STATUS.UNPAID.toString(), name: "Chưa thanh toán" },
  { _id: PAYMENT_STATUS.PAID.toString(), name: "Đã thanh toán" },
];

export enum SHIFT_SESSION_TYPE {
  CLOSE = 0,
  OPEN = 1,
}

export enum PROMOTION_STATUS {
  DRAFT = 1, // Nháp
  PREPARATION = 2, // Chuẩn bị
  RUNNING = 3, // Đang chạy
  COMPLETED = 4, // Đã hoàn thành
  CANCELLED = 5, // Hủy
}

export const PROMOTION_STATUS_VALUES: { [key in PROMOTION_STATUS]: string } = {
  [PROMOTION_STATUS.DRAFT]: "Bản nháp",
  [PROMOTION_STATUS.PREPARATION]: "Chuẩn bị",
  [PROMOTION_STATUS.RUNNING]: "Đang chạy",
  [PROMOTION_STATUS.COMPLETED]: "Đã hoàn thành",
  [PROMOTION_STATUS.CANCELLED]: "Đã huỷ",
};

export enum PROMOTION_AVAILABLE_DAYS {
  MONDAY = "1", // Thứ 2
  TUESDAY = "2", // Thứ 3
  WEDNESDAY = "3", // Thứ 4
  THURSDAY = "4", // Thứ 5
  FRIDAY = "5", // Thứ 6
  SATURDAY = "6", // Thứ 7
  SUNDAY = "7", // Chủ nhật
}

export const PROMOTION_AVAILABLE_DAYS_VALUES = {
  [PROMOTION_AVAILABLE_DAYS.MONDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.MONDAY.toString(),
    name: "Thứ 2",
  },
  [PROMOTION_AVAILABLE_DAYS.TUESDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.TUESDAY.toString(),
    name: "Thứ 3",
  },
  [PROMOTION_AVAILABLE_DAYS.WEDNESDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.WEDNESDAY.toString(),
    name: "Thứ 4",
  },
  [PROMOTION_AVAILABLE_DAYS.THURSDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.THURSDAY.toString(),
    name: "Thứ 5",
  },
  [PROMOTION_AVAILABLE_DAYS.FRIDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.FRIDAY.toString(),
    name: "Thứ 6",
  },
  [PROMOTION_AVAILABLE_DAYS.SATURDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.SATURDAY.toString(),
    name: "Thứ 7",
  },
  [PROMOTION_AVAILABLE_DAYS.SUNDAY]: {
    _id: PROMOTION_AVAILABLE_DAYS.SUNDAY.toString(),
    name: "Chủ nhật",
  },
};

export const PROMOTION_AVAILABLE_DAYS_OBJECTS: Options[] = [
  { _id: PROMOTION_AVAILABLE_DAYS.MONDAY.toString(), name: "Thứ 2" },
  { _id: PROMOTION_AVAILABLE_DAYS.TUESDAY.toString(), name: "Thứ 3" },
  { _id: PROMOTION_AVAILABLE_DAYS.WEDNESDAY.toString(), name: "Thứ 4" },
  { _id: PROMOTION_AVAILABLE_DAYS.THURSDAY.toString(), name: "Thứ 5" },
  { _id: PROMOTION_AVAILABLE_DAYS.FRIDAY.toString(), name: "Thứ 6" },
  { _id: PROMOTION_AVAILABLE_DAYS.SATURDAY.toString(), name: "Thứ 7" },
  { _id: PROMOTION_AVAILABLE_DAYS.SUNDAY.toString(), name: "Chủ nhật" },
];

export enum PROMOTION_COMBO_ACTION_TABS_ENUM {
  INFO = 0,
  COMBO = 1,
}

export const PROMOTION_COMBO_ACTION_TABS_ENUM_VALUES: {
  [key in PROMOTION_COMBO_ACTION_TABS_ENUM]: string;
} = {
  [PROMOTION_COMBO_ACTION_TABS_ENUM.INFO]: "Thông tin khuyến mãi",
  [PROMOTION_COMBO_ACTION_TABS_ENUM.COMBO]: "Quản lý Combo",
};

export enum PROMOTION_PRODUCT_TYPE {
  PRODUCT = 1,
  RECHARGE_PACKAGE = 2,
}

export const PROMOTION_PRODUCT_TYPE_VALUES = {
  [PROMOTION_PRODUCT_TYPE.PRODUCT]: {
    _id: PROMOTION_PRODUCT_TYPE.PRODUCT,
    name: "Sản phẩm",
  },
  [PROMOTION_PRODUCT_TYPE.RECHARGE_PACKAGE]: {
    _id: PROMOTION_PRODUCT_TYPE.RECHARGE_PACKAGE,
    name: "Gói nạp",
  },
};

export enum DISCOUNT_TYPE {
  AMOUNT = 1,
  PERCENT = 2,
}

export enum RECHARGE_PACKAGE_MILESTONES_TYPE_ENUM {
  AMOUNT = 1,
  PERCENT = 2,
}

export const RECHARGE_PACKAGE_MILESTONES_TYPE_ENUM_VALUES: {
  [key in RECHARGE_PACKAGE_MILESTONES_TYPE_ENUM]: string;
} = {
  [RECHARGE_PACKAGE_MILESTONES_TYPE_ENUM.AMOUNT]: "Số tiền",
  [RECHARGE_PACKAGE_MILESTONES_TYPE_ENUM.PERCENT]: "Phần trăm",
};

export enum PROMOTION_DETAIL_TABS_ENUM {
  INFO = 0,
  HISTORY = 1,
}

export const PROMOTION_DETAIL_TABS_ENUM_VALUES: {
  [key in PROMOTION_DETAIL_TABS_ENUM]: string;
} = {
  [PROMOTION_DETAIL_TABS_ENUM.INFO]: "Thông tin khuyến mãi",
  [PROMOTION_DETAIL_TABS_ENUM.HISTORY]: "Lịch sử mua khuyến mãi",
};

//TICKET
export enum PROMOTION_TICKET_ACTION_TABS_ENUM {
  INFO = 0,
  TICKET = 1,
}

export const PROMOTION_TICKET_ACTION_TABS_ENUM_VALUES: {
  [key in PROMOTION_TICKET_ACTION_TABS_ENUM]: string;
} = {
  [PROMOTION_TICKET_ACTION_TABS_ENUM.INFO]: "Thông tin khuyến mãi",
  [PROMOTION_TICKET_ACTION_TABS_ENUM.TICKET]: "Quản lý vé",
};

//CUSTOMER DISCOUNT
export enum PROMOTION_CUSTOMER_DISCOUNT_ACTION_TABS_ENUM {
  INFO = 0,
  CUSTOMER = 1,
}

export const PROMOTION_CUSTOMER_DISCOUNT_ACTION_TABS_ENUM_VALUES: {
  [key in PROMOTION_CUSTOMER_DISCOUNT_ACTION_TABS_ENUM]: string;
} = {
  [PROMOTION_CUSTOMER_DISCOUNT_ACTION_TABS_ENUM.INFO]: "Thông tin khuyến mãi",
  [PROMOTION_CUSTOMER_DISCOUNT_ACTION_TABS_ENUM.CUSTOMER]: "Khách hàng nhận ưu đãi",
};

//CUSTOMER DISCOUNT
export enum PROMOTION_AREA_DISCOUNT_ACTION_TABS_ENUM {
  INFO = 0,
  AREA = 1,
}

export const PROMOTION_AREA_DISCOUNT_ACTION_TABS_ENUM_VALUES: {
  [key in PROMOTION_AREA_DISCOUNT_ACTION_TABS_ENUM]: string;
} = {
  [PROMOTION_AREA_DISCOUNT_ACTION_TABS_ENUM.INFO]: "Thông tin khuyến mãi",
  [PROMOTION_AREA_DISCOUNT_ACTION_TABS_ENUM.AREA]: "Khu vực nhận ưu đãi",
};

export enum PROMOTION_CAMPAIGN_TYPE {
  COMBO = 1,
  TICKET = 2,
  RECHARGE_PACKAGE_MILESTONES = 3,
  MEMBERSHIP_LEVEL = 4,
  CUSTOMER_DISCOUNT = 5,
  AREA_DISCOUNT = 6,
}

export const PROMOTION_CAMPAIGN_TYPE_VALUES: {
  [key in PROMOTION_CAMPAIGN_TYPE]: string;
} = {
  [PROMOTION_CAMPAIGN_TYPE.COMBO]: "Khuyến mãi theo combo",
  [PROMOTION_CAMPAIGN_TYPE.TICKET]: "Khuyến mãi theo vé trọn gói",
  [PROMOTION_CAMPAIGN_TYPE.RECHARGE_PACKAGE_MILESTONES]: "Khuyến mãi theo gói nạp",
  [PROMOTION_CAMPAIGN_TYPE.MEMBERSHIP_LEVEL]: "Khuyến mãi theo hạng thành viên",
  [PROMOTION_CAMPAIGN_TYPE.CUSTOMER_DISCOUNT]: "Khuyến mãi theo tài khoản",
  [PROMOTION_CAMPAIGN_TYPE.AREA_DISCOUNT]: "Khuyến mãi giờ chơi theo khu vực",
};

export const enum TypeColumnKanban {
  COLUMN = "column",
  TASK = "task",
}

export enum NOTIFICATION_TYPE {
  CREATE_NEW_COMPUTER = 1,
}

export enum REFUND_METHOD {
  NOT_REFUND = 0, // Không hoàn tiền
  CASH = 1, // Hoàn tiền bằng tiền mặt
  TRANSFER = 2, // Hoàn tiền bằng tài khoản
  ACCOUNT_BALANCE = 3,
}

export enum CUSTOMER_PROMOTION_HISTORY_STATUS {
  PENDING = 1,
  // CONFIRM = 2,
  COMPLETED = 3,
  // DONE = 4,
  CANCEL = 5,
}

export enum PACKAGE_TICKET_PROMOTION_STATUS {
  PENDING = 2,
  RUNNING = 3,
  COMPLETED = 4,
  IN_ACTIVE = 5,
}

export const PAYMENT_METHOD_MAP: Record<number, { id: number; label: string }> = {
  0: { id: FOOD_ORDER_PAYMENT_METHOD_V2.CASH, label: "Tiền mặt" },
  1: { id: FOOD_ORDER_PAYMENT_METHOD_V2.MOMO, label: "MoMo" },
  2: { id: FOOD_ORDER_PAYMENT_METHOD_V2.ACCOUNT_BALANCE, label: "Tài khoản" },
  3: { id: FOOD_ORDER_PAYMENT_METHOD_V2.PAYOS, label: "Chuyển khoản" },
};

export enum AREA_STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
}
export enum ADMINISTRATIVE_UNITS_TYPE {
  CITY = "CITY",
  DISTRICT = "DISTRICT",
  WARD = "WARD",
}

export const allChooseOption = { _id: "-1", name: "Tất cả chi nhánh" };
export const allChooseOptionDepartments = { _id: "-1", name: "Tất cả bộ phận" };
export const allChooseOptionArea = { _id: "-1", name: "Tất cả khu vực" };

export enum NOTIFICATION_HISTORY_TYPE {
  COMPUTER_CONFIG = 1,
  CREATE_ORDER = 2,
  DEPOSIT = 3,
  COMPLETE_ORDER = 4,
  CREATE_RESERVATION = 5,
  CREATE_TICKET = 6,
  CREATE_COMBO = 7,
  CHAT = 8,
}
export enum CONFIRM_PAYMENT_OBJECT_TYPE {
  ORDER = 1,
  PROMOTION = 2,
  TOPUP = 3,
  PLAY_TIME_PACKAGE = 4,
}
export enum REPORT_TYPE {
  DAY = 1, // Theo ngày
  WEEK = 2, // Theo tuần
  MONTH = 3, // Theo tháng
  YEAR = 4, // Theo năm
}

export enum WALLET_HISTORY_SOURCE_TYPE {
  DEPOSIT = 1,
  ORDER = 2,
  DEDUCT_PLAYTIME = 3,
  REFUND = 4,
  DEPOSIT_PROMOTION = 5,
  WITHDRAW_PROMOTION = 6,
}

// C-03 order source
export enum ORDER_SOURCE {
  PC = 1,
  MINI_APP = 2,
  STAFF = 3,
}

